import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './AddressDocumentsMain.html?raw';
import FloatingMenu from '../../../moreCore/UI/Floating/Menu';
import StaticTable from '../../../moreCore/UI/StaticTable/StaticTable';
import AddressDocumentsEditor from './AddressDocumentsEditor/AddressDocumentsEditor';
import GenericDialog from '../../../moreCore/UI/GenericDialog/GenericDialog';
import EntityStore from '../../../moreCore/Tools/EntityStore';
import { AddressTypes } from "../../_loadingHelpers/Address";

enum DocumentClassPrintNames {
    passport = "Reisepass",
    train_bonus_card = "Bahn-Bonuskarte",
    frequent_flier_card = "Vielfliegerkarte",
    visa = "Visum"
}
class AddressDocumentsMain extends compose(_WidgetBaseSP) {
    templateString: any = template;
    private addressId: string;
    private gDisp: string;

    private storeEntries: MdsLax<InstanceType<typeof EntityStore<AddressTypes.AddressDocumentsTableEntry>>>;
    private storeDocuments: MdsLax<InstanceType<typeof EntityStore<AddressTypes.AddressDocumentChangeData>>>;

    private addNewFloatingMenu: MdsLax<InstanceType<typeof FloatingMenu>>;
    private documentsTable: MdsLax<InstanceType<typeof StaticTable>>;
    private tableContainer: HTMLElement;

    private documentList: Array<AddressTypes.AddressDocumentsTableEntry> = null;


    constructor(addressId?: string, gDisp?: string) {
        super(...(arguments as unknown as []));
        if (addressId) this.addressId = addressId;
        else this.addressId = null;
        if (gDisp) this.gDisp = gDisp;
        else this.gDisp = null;
    }

    private _onChange_StoreEntriesData() {

    }

    private _onChange_StoreDocumentsData() {

    }

    private getFloatEntrys() {
        let entries: Array<{ callback: Function, icon: string, groupname: string, label: string }> = [];

        if (this.hasUserRole("Address_AddressDocuments_Passport")) {
            entries.push({
                callback: lang.hitch(this, this._onHandle_FloatingMenuClick, "passport"),
                groupname: "documents",
                icon: "fas fa-passport",
                label: this.translate("General_Label_Passport")
            })
        }
        
        if (this.hasUserRole("Address_AddressDocuments_TrainBonusCard")) {
            entries.push({
                callback: lang.hitch(this, this._onHandle_FloatingMenuClick, "train_bonus_card"),
                groupname: "documents",
                icon: "fas fa-train",
                label: this.translate("General_Label_TrainBonusCard")
            })
        }

        if (this.hasUserRole("Address_AddressDocuments_FrequentFlierCard")) {
            entries.push({
                callback: lang.hitch(this, this._onHandle_FloatingMenuClick, "frequent_flier_card"),
                groupname: "documents",
                icon: "fas fa-plane",
                label: this.translate("General_Label_FrequentFlierCard")
            })
        }

        if (this.hasUserRole("Address_AddressDocuments_Visa")) {
            entries.push({
                callback: lang.hitch(this, this._onHandle_FloatingMenuClick, "visa"),
                groupname: "documents",
                icon: "fas fa-id-card-alt",
                label: this.translate("General_Label_Visa")
            })
        }

        return entries;
    }
    private _onHandle_FloatingMenuClick(className: string) {

        let entityId = this.addNewDocumentEntry(className);
        this.prepareDocumentEditor(className, entityId);
    }
    private addNewDocumentEntry(className: string): string {

        let newId = (Math.random() * 100000).toString();
        let newEntry: AddressTypes.AddressDocumentsTableEntry = {
            ID: newId,
            Classname: className,
            isNew: true,
            ClassPrintname: DocumentClassPrintNames[className],
            date_valid_from: null,
            date_valid_until: null,
            personal_doc_number: ""
        }
        this.storeEntries.addEntry(newEntry, "new");
        return newId;
    }
    private _onClick_NewDocument(ev: Event) {

        let entries = this.getFloatEntrys();

        this.addNewFloatingMenu = new FloatingMenu();
        this.addNewFloatingMenu.open(ev,
            entries,
            this.translate("AddressWizard__AddressDocuments_AddNew_Header")
        );
    }
    private _onTableRowClick(row: StaticTable.StaticTableRow<AddressTypes.AddressDocumentsTableEntry>) {

        let entityId = row.rowGroup.entity.ID;
        let classname = row.rowGroup.entity.Classname;

        this.StandbyStart();
        if (row.rowGroup.entity.isNew) {

            this.prepareDocumentEditor(classname, entityId);
            return;
        }
        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard_AddressDocuments_GetDocumentDataByID",
            { entityId: entityId },
            lang.hitch(this, this.prepareDocumentEditor, classname, entityId),
            (err) => {
                this.showToast(err.Message);
                this.StandbyStop();
            }
        )
    }

    private prepareDocumentEditor(classname, entityId, response?) {
        this.StandbyStop();

        let form = new AddressDocumentsEditor();
        let heading = "";
        form.setClassName(classname);
        form.setAddressId(this.addressId);
        if (response) {
            form.setData(response);
            heading = response["$Displayname"];
        } else {
            form.setAttributeValue("owner", this.gDisp, true);
            form.setNewEntityId(entityId);

            form.setStartupState("ready");
            heading = this.translate(`AddressDocument_NewHeading_ByClass_${classname}`);
        }
        if (this.storeDocuments.isEntityExisting(entityId)) form.applyAllreadyChangedData(this.storeDocuments.getEntityById(entityId));

        form.prepareFileList();

        let dlg = new GenericDialog();

        dlg.closeOnEnter = false;
        dlg.destroyOnClose = true;
        
        dlg.show(form,
            heading,
            null,
            null,
            "ok",
            (result) => {
                if (result === 1) form.externalEventHandler("ok");
                else {
                    if (this.storeEntries.isEntityNew(entityId)) {
                        this.storeEntries.deleteEntry(entityId);
                        this.storeDocuments.deleteEntry(entityId);
                    }
                    dlg.close();
                }
            },
            {
                keepOpen: true,
                closeOnEnter: false
            });
        form.on("okClicked", (data) => {
            let storeEntry: AddressTypes.AddressDocumentChangeData = { data: data, entryId: data.ID };
            let existingEntry: AddressTypes.AddressDocumentChangeData = null;

            if (this.storeDocuments.isEntityExisting(data.ID)) {
                existingEntry  = this.storeDocuments.getEntityById(data.ID);

                for (let p in existingEntry.data.changedData) {

                    if (!storeEntry.data.changedData[p]) storeEntry.data.changedData[p] = existingEntry.data.changedData[p];
                }
            }

            this.storeDocuments.changeEntry(storeEntry, true);
            this.updateTable();
            dlg.close();

            this.emitDataChanged();
        })
    }
    private emitDataChanged() {

        let data = {
            storeEntries: this.storeEntries.getDiffData(),
            storeDocuments: this.storeDocuments.getDiffData()
        }

        this.emit("AddressDocument_DataChanged", data);
    }
    private refreshData() {

        this.updateTable();
    }
    private getData() {
        this.StandbyStart();
        this.RequestManager.callfunction(
            "Webtool_API_AddressWizard_AddressDocuments_GetDocumentListTableFromAddress",
            { ID: this.addressId },
            lang.hitch(this, this._setUpData),
            (err) => {
                this.showToast(err.Message);
                this.StandbyStop();
            }
        )
    }

    private updateTable() {

        this.storeDocuments.getCurrentCompleteList().forEach((doc) => {
            
            let entry = this.storeEntries.getEntityById(doc.entryId);
            if (entry) {
                for (let p in doc.data.changedData) {
                    switch (p) {
                        case "personal_doc_number":
                        case "date_valid_from":
                        case "date_valid_until":
                            entry[p] = doc.data.changedData[p]
                            break;
                        default:
                    }
                }
                this.storeEntries.changeEntry(entry);
            }
        })

        this.documentsTable.setupFromStore(this.storeEntries);
        this.emit("AddressDocuments_TableUpdate", this.documentList.length > 0);

        this.documentList?.forEach(d => {
            if (d.toDelete === true) {
                this.disableNode(this.documentsTable.getRowGroupByKeyValue(d.ID, "ID").rows[0].node);
            }
        });
    }
    private deleteDocument(rowGr: StaticTable.StaticTableRowGroup<AddressTypes.AddressDocumentsTableEntry>) {

        let entry = rowGr.entity;

        if (entry.isNew) {

            this.storeEntries.deleteEntry(entry);
            this.storeDocuments.deleteEntry(entry.ID);
        }
        this.updateTable();
        this.emitDataChanged();
    }
    private _setUpData(response: { documentList: Array<AddressTypes.AddressDocumentsTableEntry>, tableLayout: { layouts: Array<any> } }) {
        if (this.documentsTable != null) this.documentsTable.destroy();

        this.storeEntries = new EntityStore();
        this.storeDocuments = new EntityStore();

        this.storeEntries.setup(response.documentList, "ID");
        this.storeEntries.on("change", lang.hitch(this, this._onChange_StoreEntriesData));

        this.storeDocuments.setup([], "entryId");
        this.storeEntries.on("change", lang.hitch(this, this._onChange_StoreDocumentsData));

        this.documentsTable = new StaticTable();
        this.documentsTable.placeAt(this.tableContainer);
        this.documentsTable.setCyAttribute("addressDocumentsMain");

        this.documentsTable.setLayout(response.tableLayout.layouts[0]);
        this.documentsTable.setRowClick(lang.hitch(this, this._onTableRowClick));
        this.documentsTable.addDefaultRowActionButton("delete", lang.hitch(this, this.deleteDocument));

        this.documentList = response.documentList;

        this.updateTable();
        this.StandbyStop();
    }
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";

        this.getData();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(AddressDocumentsMain);